(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sc-multicolumns-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.scmcInit) return;
      root.dataset.scmcInit = '1';

      var track = root.querySelector('[data-scmc-track]');
      var prev = root.querySelector('[data-scmc-prev]');
      var next = root.querySelector('[data-scmc-next]');
      var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var c = track.querySelector('.scmc__item');
        if (!c) return 0;
        var g = parseFloat(getComputedStyle(track).columnGap) || 0;
        return c.offsetWidth + g;
      }
      function scrollable() { return track.scrollWidth > track.clientWidth + 2; }
      function updateNav() {
        if (!prev || !next) return;
        if (!scrollable()) { prev.hidden = true; next.hidden = true; return; }
        prev.hidden = false; next.hidden = false;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: rm ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: rm ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      var auto = root.dataset.autoplay === 'true';
      var speed = (parseFloat(root.dataset.autoplaySpeed) || 3) * 1000;
      var timer = null;
      function advance() {
        if (!scrollable()) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: rm ? 'auto' : 'smooth' });
        else track.scrollBy({ left: step(), behavior: rm ? 'auto' : 'smooth' });
      }
      function start() { if (auto && !rm && !timer) timer = setInterval(advance, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (auto && !rm) {
        start();
        root.addEventListener('pointerenter', stop);
        root.addEventListener('pointerleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
          }, { threshold: 0 }).observe(root);
        }
      }

      var vids = root.querySelectorAll('video[data-src]');
      if (vids.length) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) {
            es.forEach(function (e) {
              var v = e.target;
              if (e.isIntersecting) {
                if (!v.src && v.dataset.src) v.src = v.dataset.src;
                if (v.dataset.autoplay === 'true') { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
              } else if (v.dataset.autoplay === 'true') { v.pause(); }
            });
          }, { rootMargin: '200px' });
          vids.forEach(function (v) { io.observe(v); });
        } else {
          vids.forEach(function (v) { if (v.dataset.src) v.src = v.dataset.src; });
        }
      }
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-scmc]').forEach(init); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
